<template>
	<el-container id="test" v-loading="test_load">
		<div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
		<div class="testCon">
			<div class="test_tit">
				<h1 class="titCon">{{test_tit}}</h1>
				<div class="count">
					<!-- <p class="time">本次考试限时{{test_time}}分钟，共{{test_exam}}道题，满分为{{test_fen}}分</p> -->
                    <p style="color:#000">本次考试您的分数是：<span style="color:red;font-size: 22px;font-weight: 700;">{{fenshu}}</span> </p>
				</div>
			</div>
			<el-form :model="testForm">
				<!-- {{formal}} -->
				<div v-for="(item,index) in formal" :key="index">
					<div class="big_question" v-if="item.type!='universal'">
						<!-- {{formal}}
						{{key}} -->
						<div class="big_qs_tit">
							<font class="qiZh">{{$selfjs.qiZh(index+1)}}、</font>
							<font class="headline">{{item.headline==''?timuleixing[item.type]:item.headline}}</font>
							<!-- <font class="big_qs_count">（共{{item.list.length}}题）</font> -->
						</div>
						<ul :class="item.type">
							<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
								<p><font>{{(ti_index+1)}}.</font><span class="sp" v-html="tiObj.title.replace(/\n/g, '<br>')"></span>（{{tiObj.score}}分）</p>
								<img v-if="tiObj.question_img!=''" :src="global.oss_link+tiObj.question_img" alt="">
								<dl class="pr" v-if="item.type=='single'">
                    	            <div class="mask"></div>
									<el-form-item v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index">
										<el-radio-group v-model="tiObj.exam_answer.answer" >
											<el-radio :label="chObj.flag">{{chObj.flag+'. '+chObj.content}}</el-radio>
										</el-radio-group>
									</el-form-item>
								</dl>
								<dl class="pr" v-if="item.type=='multiple'">
                    	            <div class="mask"></div>
									<el-form-item>
										<el-checkbox-group v-model="tiObj.value">
											<el-checkbox v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index" :label="chObj.flag" :name="item.type+ti_index+ch_index">{{chObj.flag+'. '+chObj.content}}</el-checkbox>
										</el-checkbox-group>
									</el-form-item>
								</dl>
								<dl class="pr" v-if="item.type=='judgement'">
                    	            <div class="mask"></div>
									<el-form-item>
										<el-radio-group v-model="tiObj.exam_answer.answer">
											<el-radio label="对"></el-radio>
											<el-radio label="错"></el-radio>
										</el-radio-group>
									</el-form-item>
								</dl>
								<dl v-if="item.type=='fill'||item.type=='other1'||item.type=='other2'">
									<span class="zhengque" style="margin-right: 8px;border-radius: 3px;font-size: 14px;padding: 2px 5px;background-color: rgb(109, 167, 226);color: rgb(255, 255, 255);">考生回答：</span>{{tiObj.exam_answer.answer}}
								</dl>
								<dl v-if="item.type=='open'">
									<el-form-item v-for="ch_index in tiObj.fill_count" :key="ch_index">
										<el-input type="textarea" v-model="tiObj.exam_answer.answer" autocomplete="off" readonly></el-input>
									</el-form-item>
								</dl>
								<div v-if="tiObj.exam_img.length!=0"><span class="zhengque">考生图片</span><img :src="global.oss_link+img.exam_img" alt="" v-for="(img,imgind) in tiObj.exam_img" :key="imgind"></div>
								<div v-if="tiObj.correct_answer">
									<div class="daan" v-if="item.type=='multiple'||item.type=='fill'||item.type=='other1'||item.type=='other2'"><span class="zhengque">正确答案</span>{{tiObj.correct_answer.replace(/\|\|/g,"、")}}</div>
									<div class="daan" v-else><span class="zhengque">正确答案</span>{{tiObj.correct_answer}}</div>
								</div>
								<div class="daan" v-if="tiObj.answer_img">
									<span class="zhengque">答案图片</span>
									<img v-if="tiObj.answer_img!=''" :src="global.oss_link+tiObj.answer_img" alt="">
								</div>
								<div class="daan" v-if="tiObj.answer.analysis"><span class="zhengque">答案解析</span>{{tiObj.answer.analysis}}</div>
								<div v-if="tiObj.analyses.length" class="analyses_video">
									<div v-for="(analys_item,analys_i) in tiObj.analyses" :key="analys_i">
										<!-- :poster="analys_item.video.poster" -->
										<video v-if="analys_item.video" style="width: 80%; margin: 30px 0;" controls>
    									    <source
    									        :src="analys_item.video.url"
    									        type="video/mp4">
    									    您的浏览器不支持视频标签。
    									</video>
									</div>
								</div>
                    	        <div class="defen" v-if="item.type=='fill'||item.type=='other1'||item.type=='other2'||item.type=='open'"><span class="defenspan">得分</span>{{tiObj.exam_answer.user_score|user_score_text}}</div>
								<div class="defen" v-else><span class="defenspan">得分</span>{{tiObj.exam_answer.user_score}}</div>
								<div class="daan" v-if="tiObj.exam_answer.opinion"><span class="zhengque">批改意见</span>{{tiObj.exam_answer.opinion}}</div>
							</li>
						</ul>
					</div>
					<div v-else>
						<div class="big_question" v-for="(item,index) in item.list" :key="index+'sub'">
							<div>
								<div v-html="item.title" style="padding: 25px 0;"></div>
								<div v-for="(children_item,sub_i) in item.children" :key="children_item.id+'sub'+sub_i">
									<ul :class="children_item.type">
										<li :class="'universal'+index+sub_i">
											<p><font>{{(children_item.universal_sort)}}.</font><span class="sp" v-html="children_item.title.replace(/\n/g, '<br>')"></span>（{{children_item.score}}分）</p>
											<p v-if="children_item.question_img" class="question_img">
												<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
											</p>
											<dl class="pr" v-if="children_item.type=='single'">
                		    		            <div class="mask"></div>
												<el-form-item v-for="(chObj,ch_index) in children_item.choices" :key="ch_index">
													<el-radio-group v-model="children_item.exam_answer.answer" >
														<el-radio :label="chObj.flag">{{chObj.flag+'. '+chObj.content}}</el-radio>
													</el-radio-group>
												</el-form-item>
											</dl>
											<dl class="pr" v-if="children_item.type=='multiple'">
                		    		            <div class="mask"></div>
												<el-form-item>
													<el-checkbox-group v-model="children_item.value">
														<el-checkbox v-for="(chObj,ch_index) in children_item.choices" :key="ch_index" :label="chObj.flag" :name="children_item.type+index+ch_index">{{chObj.flag+'. '+chObj.content}}</el-checkbox>
													</el-checkbox-group>
												</el-form-item>
											</dl>
											<dl class="pr" v-if="children_item.type=='judgement'">
                		    		            <div class="mask"></div>
												<el-form-item>
													<el-radio-group v-model="children_item.exam_answer.answer">
														<el-radio label="对"></el-radio>
														<el-radio label="错"></el-radio>
													</el-radio-group>
												</el-form-item>
											</dl>
											<dl v-if="children_item.type=='fill'||item.type=='other1'||item.type=='other2'">
												<span class="zhengque" style="margin-right: 8px;border-radius: 3px;font-size: 14px;padding: 2px 5px;background-color: rgb(109, 167, 226);color: rgb(255, 255, 255);">考生回答</span>{{children_item.exam_answer.answer}}
											</dl>
											<dl v-if="children_item.type=='open'">
												<el-form-item>
													<el-input type="textarea" v-model="children_item.exam_answer.answer" autocomplete="off" readonly></el-input>
												</el-form-item>
											</dl>
											<div v-if="children_item.exam_img.length">
												<span class="zhengque">考生图片</span>
												<img :src="ali_oss+img.exam_img" alt="" v-for="(img,imgind) in children_item.exam_img" :key="imgind" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+img.exam_img})">
											</div>
                		    		        <div class="daan" v-if="children_item.type=='fill'||children_item.type=='other1'||children_item.type=='other2'"><span class="zhengque">正确答案</span>{{children_item.correct_answer.replace(/\|\|/g,"、")}}</div>
                		    		        <div class="daan" v-else><span class="zhengque">正确答案</span>{{children_item.correct_answer}}</div>
											<div class="daan" v-if="children_item.answer_img">
												<span class="zhengque">答案图片</span>
												<img :src="ali_oss+children_item.answer_img" alt="" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.answer_img})">
											</div>
											<div class="daan" v-if="children_item.answer.analysis!=''"><span class="zhengque">答案解析</span>{{children_item.answer.analysis}}</div>
											<div v-if="children_item.analyses.length" class="analyses_video">
												<div v-for="(analys_item,analys_i) in children_item.analyses" :key="analys_i">
													<!-- :poster="analys_item.video.poster" -->
													<video v-if="analys_item.video" style="width: 80%; margin: 30px 0;" controls>
    												    <source
    												        :src="analys_item.video.url"
    												        type="video/mp4">
    												    您的浏览器不支持视频标签。
    												</video>
												</div>
											</div>
                		    		        <div class="defen" v-if="children_item.type=='fill'||children_item.type=='other1'||children_item.type=='other2'||children_item.type=='open'"><span class="defenspan">得分</span>{{children_item.exam_answer.user_score|user_score_text}}</div>
											<div class="defen" v-else><span class="defenspan">得分</span>{{children_item.exam_answer.user_score}}</div>
											<div class="daan" v-if="children_item.exam_answer.opinion!=''"><span class="zhengque">批改意见</span>{{children_item.exam_answer.opinion}}</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<el-dialog
			class="question_preview"
			title=""
			width="intial"
			:visible.sync="question_preview_visible" center>
			<span slot="footer" class="dialog-footer"><img :src="preview_img_src"></span>
		</el-dialog>
	</el-container>
</template>

<script>
var tnum
export default {
	name: 'test'
	,data () {
		tnum=0;
		let formal={
			single:{	 //单选题
				list: [
				],
			},
			multiple:{		//多选题
				list:[
				],
			},
			judgement:{		//判断题
				list:[
				],
			},
			fill:{		//填空题
				list:[
				],
			},
			open:{		//主观题
				list:[
				],
			},
			universal:{
				list:[]
			}
		}

		return {
			xieyi:window.location.protocol,
			ali_oss:this.global.oss_link,
			timuleixing:{single:'单选题',multiple:'多选',judgement:'判断题',fill:'填空题',open:'问答题',other1:'名词解释',other2:'论述分析题',},
			time_cal_show:false,
			test_load:true,
            asd:['A','B'],
			location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
			},{
				title:"我的考试",
				router:"/web/exam_list",
				name: 'exam_list',
				activeIndex: 'index',
				query:{page:'exam_list'}
			}],
			test_tit:'',
			test_time:0,
			test_fen:0,
			test_exam:0,
            fenshu:'',
			testForm:{
				single:[],
				multiple:[],
				judgement:[],
				fill:[],
				open:[],
			},
			formal:formal,
			timeCal:"0:00:00",
			universal_sort:0,
			question_preview_visible:false,
			preview_img_src:'',
		}
	}
	,mounted:function(){
		var that=this
			,token=this.$cookies.get("token")
			,serverSrc=that.global.serverSrc
			,qianzui=that.global.qianzui
			,question_info
		//获取试题信息
		let url = serverSrc + qianzui + "/exam/user_exam"
		this.$ajax.get(url,{
            params:{
                test_id:this.$route.query.test_id,
                log_id:this.$route.query.log_id
            }
		})
		.then(function(res){
			// console.log(res);
			let resData=res.data
			
			if(resData.code==0){
				question_info = resData.data
				// console.log(question_info)
				that.test_load = false
				that.test_tit = question_info.test_title
				that.test_time = question_info.exam_duration || 10
				that.timeTotal = that.test_time * 60
				that.test_fen = question_info.max_score || 10
				that.test_exam = question_info.question_count || 30
				that.formal = question_info.question
				that.fenshu = question_info.log.score
				for (let j = 0; j < that.formal.length; j++) {
					let tiNnum=that.formal[j].list.length,
						tiArr=[],
						formal_obj = that.formal[j]
					// console.log(question_info.question[key]);
					for(let t=0;t<tiNnum;t++){
						let tiId = formal_obj.list[t].id,
							tianArr = []
						if(formal_obj.type == "fill"){
							for(let f=0;f<formal_obj.list[t].fill_count;f++){
								tianArr.push("")
							}
						}
						tiArr.push({"question_id":tiId, "answer":tianArr})
					}
					// that.testForm[key] = tiArr
					// console.log(formal_obj);
					if (formal_obj.type == 'multiple') {
						formal_obj.list.map(function(v,i,arr){
							if(v.exam_answer.answer.length==1){
								v.value=[v.exam_answer.answer]
							}else{
								v.value=v.exam_answer.answer.split("、")
							}
						}) 
						// console.log(formal_obj.list);
					}else if(formal_obj.type == 'fill'){
						formal_obj.list.forEach(function(v,i,arr){
							v.value=v.exam_answer.answer.split("||")
                		    formal_obj.list[i].value.forEach(function(v2,i2,arr2){
                		        that.formal.list.fill[i].value[i2]={
                		            daan:v2
                		        }
                		    })
						})
					}else if(formal_obj.type == 'universal'){
						for (let i = 0; i < formal_obj.list.length; i++) {
							let uni_obj = formal_obj.list[i]
							for (let l = 0; l < uni_obj.children.length; l++) {
								that.universal_sort++
								formal_obj.list[i].children[l].universal_sort = that.universal_sort

								if(uni_obj.children[l].type=='multiple'){
									if(uni_obj.children[l].exam_answer.answer.length==1){
										uni_obj.children[l].value=[v.exam_answer.answer]
									}else{
										uni_obj.children[l].value=uni_obj.children[l].exam_answer.answer.split("、")
									}
								}
							}
						}
					}
				}
                
			}else{
				that.$message.error('无考试信息');
			}
		})
	}
	,methods:{
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//离开页面函数
		pageout(go){
            go();
		},
		handlePictureCardPreview(file) {
			// console.log(file);
			// console.log('点击了预览按钮')
			this.question_preview_visible = true
			this.preview_img_src = file.url
		},
		
	},
	computed:{
	},
	beforeRouteLeave(to, form, next){
		// console.log(this.timeTotal);
		clearTimeout(this.global.pageTimer['examTime'])
		if(this.timeTotal != 0){
			this.pageout(next)
		}else{
			next();
		}
	},
	filters:{
		user_score_text(val){
			let res = val
			if(val == 0){
				res = '主观题不自动评分，请参考答案解析。'
			}
			return res
		}
	},
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
#index{background:#f4f4f4;}
.zhengque{
	margin-top: 5px;
    margin-right: 8px;
    border-radius: 3px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: rgb(109, 167, 226);
    color: rgb(255, 255, 255);
}
.daan{
    margin-top: 10px;
    font-size: 16px;
	word-wrap:break-word;
}
.defen{
    margin-top: 10px;
    font-size: 16px;
}
.defenspan{
    margin-right: 8px;
    border-radius: 3px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: #76d963;
    color: rgb(255, 255, 255);
}
/* .el-radio__input.is-disabled .el-radio__inner::after{
    background-color:#409EFF
} */
 .mask{
    position:absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
 }
 .pr{
     position: relative;
	 
 }
 .sp{
	color: #333 !important; 
    margin-left: 0 !important;
 }
 img{width: 100px;margin-bottom: 5px;}
</style>


// WEBPACK FOOTER //
// src/components/course_info/jieguo.vue